import React from "react";
import ClientValidationStatistics from "../../promotions/statistics/ClientValidationStatistics";
import Clients from "../../clients/Clients";
import styles from "./ClientsWithStatistics.module.scss";

const ClientsWithStatistics = () => {
  return (
    <div className={styles.container}>
      <div className={styles.statisticsSection}>
        <ClientValidationStatistics embedded />
      </div>
      <div className={styles.clientsSection}>
        <Clients />
      </div>
    </div>
  );
};

export default ClientsWithStatistics;

